export const SET_UNREAD_MESSAGES = 'SET_UNREAD_MESSAGES'

export default function unreadMessages(state = 0, action) {
  switch (action.type) {
    case SET_UNREAD_MESSAGES: {
      const { unreadCount } = action

      // if unreadCount is 0, it means we've seen all messages
      // else we should add the count to the actual number
      return unreadCount === 0 ? unreadCount : state + unreadCount
    }

    default: {
      return state
    }
  }
}
